import { Button, Input, notification, Spin } from 'antd';
import { useState } from 'react';
import { Dynamics } from '@/services/dynamics/dynamics';
import { entityFields } from '@/components/CallPanel/config';
import { LoadingOutlined } from '@ant-design/icons';
import './Forms.scss';
import {
  getFieldValidationConfigForObject,
  validateFormData,
  getErrorIfNotValid,
} from './FormValidationConfig';

const antIcon = <LoadingOutlined spin />;
const FIELD_VALIDATION_CONFIG = getFieldValidationConfigForObject('Lead');
interface IProps {
  setUnsavedFormData: (data: any) => void;
  data: any;
  prefilledPhone: string;
}

export const NewLeadForm = ({
  setUnsavedFormData,
  data,
  prefilledPhone,
}: IProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [notificationApi, contextHolder] = notification.useNotification();
  const [formData, setFormData] = useState(
    data?.Lead || {
      businessPhone: '',
      email: '',
      firstName: '',
      lastName: '',
      mobilePhone: prefilledPhone,
    },
  );

  const [formDataErrors, setFormDataErrors] = useState({
    businessPhone: '',
    email: '',
    firstName: '',
    lastName: '',
    mobilePhone: '',
  });

  const changeValue = (item: string) => {
    return (e) => {
      setUnsavedFormData({
        Lead: {
          ...formData,
          [item]: e.target.value,
        },
      });
      setFormData({
        ...formData,
        [item]: e.target.value,
      });
      setFormDataErrors({
        ...formDataErrors,
        [item]: getErrorIfNotValid(
          e.target.value,
          FIELD_VALIDATION_CONFIG[item],
        ),
      });
    };
  };

  const validate = () => {
    const errors = {
      businessPhone: '',
      email: '',
      firstName: '',
      lastName: '',
      mobilePhone: '',
    };

    const isOk = validateFormData(formData, errors, FIELD_VALIDATION_CONFIG);
    setFormDataErrors(errors);
    return isOk;
  };

  const showRes = async () => {
    const isValid = validate();
    const data = {
      firstname: formData.firstName?.trim(),
      lastname: formData.lastName?.trim(),
      fullname: `${formData.firstName?.trim()} ${formData.lastName?.trim()}`,
      emailaddress1: formData.email?.trim(),
      mobilephone: formData.mobilePhone?.trim(),
      telephone1: formData.businessPhone?.trim(),
    };
    if (isValid) {
      setIsLoading(true);
      await Dynamics.saveNewEntity('lead', data);
      setIsLoading(false);
      setFormData({
        businessPhone: '',
        email: '',
        firstName: '',
        lastName: '',
        mobilePhone: '',
      });
      setUnsavedFormData(null);
      setTimeout(() => {
        setTimeout(() => {
          notificationApi.success({
            message: 'Lead successfully created',
            placement: 'bottomRight',
            duration: 3,
            className: 'notifications',
          });
        }, 0);
      }, 0);
    }
  };

  return isLoading ? (
    <Spin className="spinner" indicator={antIcon} />
  ) : (
    <div>
      {contextHolder}
      <p className="heading">Fill in the form</p>
      <div className="form-container">
        {Object.keys(entityFields.lead).map((item) => {
          return (
            <div key={item} className="line">
              {entityFields.lead[item]}
              <Input
                placeholder={entityFields.lead[item]}
                value={formData[item]}
                onChange={changeValue(item)}
                status={formDataErrors[item] ? 'error' : ''}
              />
              {formDataErrors[item] ? (
                <div className="form-error">{formDataErrors[item]}</div>
              ) : (
                <></>
              )}
            </div>
          );
        })}
      </div>
      <div className="button-block">
        <Button onClick={showRes} data-testid="create-lead">
          Submit
        </Button>
      </div>
    </div>
  );
};
